export const CTXPCohesionConfig = {
  fuse: {
    endpoint: 'https://www.choosetexaspower.org/fuse',
  },
  monarch: {
    autoRequest: {
      enabled: true,
      suppressPlacements: true,
      timeout: 15000,
    },
    sourceId: 'b3a53a7a-293b-4147-b3e1-6e2a15b99554',
    token: '23cf91f0-c7af-418c-95d2-dc31edbbb60f',
    cookies: [
      'tglr_sess_count',
      'ctxp-returning-visitor',
      'ctxp-rv-session-last-visit-age-days',
      'lpAnswers',
    ],
  },
  tagular: {
    apiHost: 'https://www.choosetexaspower.org/tagular/v2/t',
    apiKey: 'ffc8ff8a-1975-4ec4-8d59-900718adb53d',
    cookieDomain: 'choosetexaspower.org',
    domainWhitelist: ['electricrates.choosetexaspower.org'],
    iframeAllowList: ['https://offers.qa.bankrate.com', 'https://offers.bankrate.com'],
    sourceKey: 'src_1NT29hTnJEFSEP9pHt4DrVzDa75',
    writeKey: 'wk_1NT29m68sZXzLxpfcen0gq1bM00',
  },
}
